<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('session lifetime') }}</span>
                  </v-toolbar-title>

                  <v-layout fill-height justify-end align-center>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'submit'"
                      @click="() => submit()">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'done'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('save') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="!edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'edit'"
                      @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'edit'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator"  
                      :data-testid="$options.name + '__btn__' + 'cancelEdit'"
                      @click="() => cancelEdit()">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'close'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('cancel') }}</span>
                    </v-tooltip>

                  </v-layout>

                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0>

                  <v-layout column fill-height justify-start pt-1>

                    <v-layout v-for="(role, i) in Object.keys(getFields)" :key='i' shrink justify-start >

                      <v-layout fill-height justify-start pb-1>

                        <v-flex xs4 align-content-center pa-0>
                          <v-text-field
                            :value="$t(role)"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :type="'number'"
                            :data-testid="$options.name + '__text-field__' + role"
                            v-model="model[role]"
                            light
                            auto-grow
                            outline
                            :readonly="!edit"
                            class="white"
                            hide-details               
                            :rows="1"
                            color="accent"
                            :suffix="$t('minutes')"
                          >                     
                          </v-text-field>
                          
                        </v-flex>

                      </v-layout>
                      
                    </v-layout>

                  </v-layout>
                  
                </v-layout>

              </template>

            </scroll-area>

    </v-layout>

  </v-container>

</template>

<script lang="ts">

import { defineComponent } from 'vue';
import scrollArea from '@/nms/components/partials/scrollarea.vue';
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue';

interface SessionLifetimeModel {
  [key: string]: Object;
}

interface BridgeResponse {
  options?: {
    key_ttl: SessionLifetimeModel;
  };
}

interface UpdateData {
  options: {
    key_ttl: SessionLifetimeModel;
  };
}

export default defineComponent ({

  name: 'SESSION_SETTINGS',

  components: {
    scrollArea,
    svgIcon
  },

  props: {},

  computed: {

    getFields(): SessionLifetimeModel {
      return this.model;
    },

  },

  watch: {},

  data: () => ({
    
    edit: false as boolean,
    model: {} as SessionLifetimeModel,

  }),

  created () {
    this.setup()
  },

  methods: {

    setup(): void {
      this.loadSessionLifetime()
    },

    async loadSessionLifetime(): Promise<void> {
      console.log(this.$options.name, 'loadSessionLifetime', 'START');
      try {
        // let folder = await this.$bridge.getByPath('/config/auth') as BridgeResponse;
        let folder = await this.$bridge.customQuery('core', 'users/ttlRolesnms', {}, 'get');
        console.log(this.$options.name, 'loadSessionLifetime', 'folder', folder);
        if(folder) {
          let model_ = {}
          folder.forEach(role => {
            model_[role.role_nms] = role.ttl_minute
          })
          this.model = { ...model_ };
          // console.log(this.$options.name, 'loadSessionLifetime folder', folder);
          // console.log(this.$options.name, 'loadSessionLifetime this.model', this.model);
        }
        // if(folder && folder.options?.key_ttl) {
        //   this.model = { ...folder.options.key_ttl };
        //   console.log(this.$options.name, 'loadSessionLifetime folder', folder);
        //   console.log(this.$options.name, 'loadSessionLifetime this.model', this.model);
        // }
      }
      catch(error) {
        console.error(this.$options.name, 'loadSessionLifetime smth wrong', error);
      }
    },

    async cancelEdit(): Promise <void> {
      this.edit = false
      this.setup()
    },

    async submit(): Promise <void> {
      console.log(this.$options.name, 'submit', 'START');
      try {
        let model_ = {}
        Object.keys(this.model).forEach(key => {
          model_[key] = Number(this.model[key])
        })
        // const updData: UpdateData = {
        //   options: {
        //     key_ttl: { ...this.model }
        //   }
        // };
        // const obj = await (this as any).$bridge.getByPath('/config/auth');
        // let u = await obj.update(updData);
        let u = await (this as any).$bridge.customQuery('core', 'users/changeTtlSessionNms', { ...model_ }, 'post')
        
        console.log(this.$options.name, 'submit', 'updated', u);
        (this as any).$dialog.notify.success("Параметры успешно обновлены", {
          timeout: 2000
        })

        this.edit = false;
        this.setup();
        
      }
      catch(error) {
        console.error(this.$options.name, 'submit smth wrong', error);
      }
    },

  }

})
</script>

<style lang="css" scoped>
</style>
